<template>
<div>
    <v-navigation-drawer
            v-model="drawer"
            :mini-variant.sync="mini"
            dark
            permanent
            width="180px"
            class="left-menu-nav"
        >
        <v-list-item class="px-2">
            <v-btn
            icon
            @click.stop="$emit('drawerChange', false)"
            v-if="mini"
            >
            <i class="nav__link-icon material-icons mdi-36px mdi mdi-view-headline"></i>
            </v-btn>
            <v-btn
            icon
            @click.stop="$emit('drawerChange', true)"
             v-else
            >
            <i class="nav__link-icon material-icons mdi-36px mdi mdi-close"></i>
            </v-btn>
        </v-list-item>
        <v-divider></v-divider>
        <v-list dense class="left-nav">
           <v-list-item
            v-if="getUserData && getUserData.user.id"
            @click.stop="navRoute('/dashboard')"
            to='/dashboard'
            v-show="base.canAccess()"
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-view-list-outline"></i>
            </v-list-item-icon>
            </v-list-item>

            <v-list-item
            v-if="getUserData && getUserData.user.id"
            @click.stop="navRoute('/status')"
            to='/status'
            v-show="base.canAccess()"
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>Status</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon >
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-checkbox-marked-circle-outline"></i>
            </v-list-item-icon>
            </v-list-item>
            <v-list-item
            v-if="getUserData && getUserData.user.id"
            @click.stop="navRoute('/history')"
            to='/history'
            v-show="base.canAccess()"
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>History</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-file-search-outline"></i>
            </v-list-item-icon>
            </v-list-item>
            <v-list-item
            v-if="getUserData && getUserData.user.id"
            @click.stop="navRoute('/pairing')"
            to='/pairing'
            v-show="base.canAccess() || base.canAccessPairinig()"
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>Pairing</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-cellphone-android"></i>
            </v-list-item-icon>
            </v-list-item>
            <v-list-item v-if="getUserData && getUserData.user.id" @click.stop="navRoute('/comments')" to='/comments'
          v-show="base.canAccess() || base.canAccessPairinig()">
          <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
            <v-list-item-title>Comments</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <i class="nav__link-icon material-icons mdi mdi-36px mdi-comment-edit-outline"></i>
          </v-list-item-icon>
        </v-list-item>
            <v-list-item
            v-if="getUserData && getUserData.user.id"
            @click.stop="navRoute('/profile')"
            to='/profile'
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>My Profile</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-account-outline"></i>
            </v-list-item-icon>
            </v-list-item>
            <v-list-item
            v-if="getUserData && getUserData.user.id"
            @click.stop="navRoute('/org')"
            to='/org'
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>Organization</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-lan"></i>
            </v-list-item-icon>
            </v-list-item>
            <v-list-item
            :href="adminURL"
            target="_blank"
            v-if="getUserData && getUserData.roleList.includes('Security Administrator')"
            >
            <v-list-item-content v-if="!mini" style="transition: width 0.2s;">
                <v-list-item-title>Admin Tools</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <i class="nav__link-icon material-icons mdi mdi-36px mdi-autorenew"></i>
            </v-list-item-icon>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
import Base from '@/plugins/factory/BaseExtensions'
  export default {
    props: {
      mini: Boolean
    },
    data () {
      return {
        drawer: this.$vuetify.breakpoint.mdAndUp ? false : true,
        adminURL: process.env.IDENTITY_URI+'/CommonReg/secured?cmd=LANDING',
        base:Base,
        items: [
          { title: 'Home', icon: 'home' },
          { title: 'My Account', icon: 'account' },
          { title: 'Users', icon: 'group' },
        ],
        
      }
    },
    computed: {
      isUserLoggedIn () {
        return this.$store.getters.isAuth
      },
      getUserData () {
        return this.$store.getters.getUserInfo
      }
    },
    methods: {
      navRoute (to) {
        this.$router.push(to)
      }
    }
  }
</script>
<style lang="scss">
.theme--light.v-navigation-drawer{
  background:#666;
}
.left-menu-nav{
  .v-list-item{
    padding:8px 8px;
    .v-list-item__title{
      font-size:0.875rem;
      white-space: initial;
    }
    .v-list-item__content {
      padding:5px 0 8px;
    }
  }
}
.left-menu-nav .v-list--dense .v-list-item .v-list-item__icon, .left-menu-nav .v-list-item--dense .v-list-item__icon{
  margin:0;
  display: flex;
  align-items: center;
  height:55px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Menu.vue